import { connect } from 'react-redux';

import {
  loadFriends,
  removeFriend,
  resetFriendsObject,
  sendFriendsRequest,
  setRemoveFriendMessage,
  setRemoveFriendSuccess,
  setSendFriendRequestMessage,
  setSendFriendRequestSuccess,
  setTotalFriendsCount,
} from '../../actions/MyFriendsActions';
import myFriendsView from '../../components/AccountSettings/MyFriends/MyFriends';
import {
  getFriends,
  getFriendsTotalCount,
  getLoadFriendsWaiting,
  getRemoveFriendMessage,
  getremoveFriendSuccess,
  getremoveFriendWaiting,
  getSendFriendsRequestMessage,
  getSendFriendsRequestSuccess,
  getSendFriendsRequestWaiting,
} from '../../components/AccountSettings/MyFriends/MyFriendsSelectors';
import { getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state) => ({
  user: getUser(state),
  sendFriendsRequestWaiting: getSendFriendsRequestWaiting(state),
  sendFriendsRequestSuccess: getSendFriendsRequestSuccess(state),
  sendFriendsRequestMessage: getSendFriendsRequestMessage(state),
  loadFriendsWaiting: getLoadFriendsWaiting(state),
  totalFriendsCount: getFriendsTotalCount(state),
  friends: getFriends(state),
  removeFriendWaiting: getremoveFriendWaiting(state),
  removeFriendSuccess: getremoveFriendSuccess(state),
  removeFriendMessage: getRemoveFriendMessage(state),
});

const mapDispatchToProps = (dispatch) => ({
  sendFriendsRequest: (email) => dispatch(sendFriendsRequest(email)),
  setSendFriendRequestSuccess: (value) =>
    dispatch(setSendFriendRequestSuccess(value)),
  setSendFriendRequestMessage: (message) =>
    dispatch(setSendFriendRequestMessage(message)),
  loadFriends: (skip, limit) => dispatch(loadFriends(skip, limit)),
  removeFriend: (friendId) => dispatch(removeFriend(friendId)),
  setRemoveFriendMessage: (message) =>
    dispatch(setRemoveFriendMessage(message)),
  setRemoveFriendSuccess: (value) => dispatch(setRemoveFriendSuccess(value)),
  resetFriendsObject: () => dispatch(resetFriendsObject()),
  setTotalFriendsCount: (count) => dispatch(setTotalFriendsCount(count)),
});

const MyFriendsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(myFriendsView);

export default MyFriendsContainer;
